import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationMetierApiService } from './organization-metier-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationMetierApiService extends GeneratedOrganizationMetierApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
